import { render } from "./OnboardIntro.vue?vue&type=template&id=ae1f8bf0"
import script from "./OnboardIntro.vue?vue&type=script&lang=js"
export * from "./OnboardIntro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__